const getItemCardText = t => ({
    buyNow: t('itemCard_buyNow'),
    ended: t('itemCard_ended'),
    fixedPrice: t('itemCard_fixedPrice'),
    newToday: t('itemCard_isNewToday'),
    notRated: t('itemCard_notRated'),
    numberOfBidsWithCount: count =>
        t('itemCard_numberOfBidsWithCount', { count }),
    onDisplay: t('itemCard_onDisplay'),
    rating: t('itemCard_rating'),
    savedToWishlist: t('itemCard_savedToWishlist'),
    saveToWishlist: t('itemCard_saveToWishlist'),
    shipping: {
        freeShipping: t('itemCard_freeShipping'),
        nonSpecifiedShipping: t('itemCard_nonSpecifiedShipping'),
        pickupOnly: t('itemCard_pickupOnly'),
        addedShippingCost: shippingPrice =>
            t('itemCard_addedShippingCost', { shippingPrice })
    }
});

export { getItemCardText };
